module.exports = __webpack_public_path__ + "img/2a698ab.png";